export default __webpack_public_path__ + "static/media/KizoBomba3DLift.1c092bcd.jpg";